import { render } from "./Ewaste.vue?vue&type=template&id=2e17d3cd"
import script from "./Ewaste.vue?vue&type=script&lang=js"
export * from "./Ewaste.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__